module.exports = "/packs/_/assets/images/flags/flag-il-13a656a58d48f055fbeb5ae49bf07fd9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/flags/flag-il.svg
// module id = 1769
// module chunks = 0